interface VoiceSelectorProps {
  voices: readonly string[];
  value?: string;
  onChange: (voice: string) => void;
  /** Optional per-voice descriptions; the selected one shows as helper text. */
  descriptions?: Record<string, string>;
}

/**
 * Shared brand-voice picker — style-guide selection pills (fully rounded,
 * selected fills indigo). Used in onboarding and the brand editor so the field
 * looks identical in both places.
 */
export default function VoiceSelector({
  voices,
  value,
  onChange,
  descriptions,
}: VoiceSelectorProps) {
  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {voices.map((v) => (
          <button
            key={v}
            type="button"
            onClick={() => onChange(v)}
            title={descriptions?.[v]}
            aria-pressed={value === v}
            className={`px-5 py-2.5 rounded-full text-[15px] font-bold border capitalize transition-colors ${
              value === v
                ? "bg-brand-500 text-white border-brand-500"
                : "border-hairline text-slate hover:border-brand-400"
            }`}
          >
            {v}
          </button>
        ))}
      </div>
      {descriptions && value && descriptions[value] && (
        <p className="text-xs text-muted mt-2 leading-snug">
          {descriptions[value]}
        </p>
      )}
    </div>
  );
}
